<template>
  <div>
    <div class="page-title">New Venue Events List</div>
    <Form v-model="form" :submit="create" btnText="Add Venue Events List" />
  </div>
</template>

<script>
import Form from "./_form.venue-events-lists.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Venue Event",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.VenueEventsList.new();
      this.form = data;
    },
    async create() {
      await this.$api.VenueEventsList.create(this.form);
      this.$router.push("/widgets/venue-events-lists");
    },
  },
};
</script>

<style></style>
